module.exports = __webpack_public_path__ + "img/trips-top-background.4d1eff0a.jpg";